import {  Outlet } from "react-router-dom";
import "./App.css";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import { ToastContainer } from "react-toastify";
// eslint-disable-next-line
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import summaryApi from "./common/Api";
import { useEffect, useState } from "react";
import UserContext from "./context/context";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { setUser } from "./store/userSlice";
import { AuthProvider } from "./context/AuthContext";
import { login } from "./store/authSlice";
import Loading from "./components/loading/loading";

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
};

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [cartCount, setCartCount] = useState(0);
  // const user = useSelector(state => state.user?.user?.user);

  const fetchUserDetails = async () => {
    const tokenApi = Cookies.get("tokenApi");
    // console.log("token from userDetails", tokenApi);
    try {
      if (tokenApi) {
        const response = await axios.get(summaryApi.currentUser.url, {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
          },
          withCredentials: true,
        });
        dispatch(login(tokenApi));
        dispatch(setUser(response.data));
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching Cart Count", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCartCount = async () => {
    const tokenApi = Cookies.get("tokenApi");
    // console.log("token from userDetails", tokenApi);
    try {
      if (tokenApi) {
        const response = await axios.get(summaryApi.cartProductCount.url, {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
          },
          withCredentials: true,
        });
        dispatch(login(tokenApi));
        setCartCount(response?.data?.data);
        // dispatch(setCartCount(response?.data?.data));
        // console.log("cartCount", response.data.data);
        return response?.data?.data;
      }
    } catch (error) {
      console.error("Error fetching cart Count", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserDetails();
    fetchCartCount();
  },[]);

  if (loading) {
    return (
      <div style={styles.wrapper}>
        <Loading />
      </div>
    );
  }

  return (
    <>
      <AuthProvider>
        <UserContext.Provider
          value={{ fetchUserDetails, cartCount, fetchCartCount, setCartCount }}
        >
          <ToastContainer position="top-center" />
          <Header UserDetails={fetchUserDetails} />
          <main className="min-h-[calc(100vh-38px)] pt-16  scroll-x-hidden scroll-none">
            <Outlet />
          </main>
          <Footer />
        </UserContext.Provider>
      </AuthProvider>
    </>
  );
}

export default App;
